<template>
  <div class="columns is-multiline is-mobile">
    <a class="column is-half-mobile is-one-third-tablet is-one-quarter-desktop"
       v-for="object in objects"
       :key="chapter.shortname + '-' + object.id"
       @click="$emit('open-details', object)">
      <ArchiveItem :item="object"></ArchiveItem>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ArchiveItem from '@/components/ArchiveItem.vue'

export default {
  name: 'archiveGrid',
  components: { ArchiveItem },
  props: ['objects'],
  computed: {
    ...mapGetters(['chapter'])
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ArchiveGrid.vue?546cc6d0